<div style="margin: 0;padding: 0;height:100%;width:100%">
    <div class="header">
        <div>
            司机详情
        </div>
        <div>
            <i class="pi pi-times p-cursor" (click)="closeDetail()"></i>
        </div>
    </div>
    <div class="body" style="position: relative;">
        <table>
            <tr style="width:100%;height:100%;">
                <td class="panel-left">
                    <!-- 左 -->
                    <div class="panel-detail panel-background">
                        <div class="panel-detail-header">
                            <div class="company-name">
                                {{localDriverDetail['realname']}}
                            </div>
                            <div class="company-tel">
                                <img src="assets/icon/map-location.png" alt="">&nbsp;
                                <span *ngIf="localDriverDetail['formattedAddress']">
                                    {{localDriverDetail.formattedAddress}}
                                    <span class="auditor" [pTooltip]="'定位时间：'+this.bc.setCreateTime(localDriverDetail['addTime']*1000)"
                                        tooltipPosition="top">（{{this.bc.dateDiff(localDriverDetail['addTime']*1000)}}）</span>
                                </span>
                                <span class="auditor" *ngIf="!localDriverDetail['formattedAddress']">暂无</span>
                            </div>
                            <div class="panel-detail-status p-d-flex p-ai-center p-jc-center">
                                <img class="p-mr-3" *ngIf="localDriverDetail['politicalOutlook']==1" pTooltip="政治面貌：党员" tooltipPosition="top"
                                    src="assets/icon/party-emblem.png" alt="">

                                <img class="p-mr-3" *ngIf="localDriverDetail['source']==0" [pTooltip]="'来源：'+this.source[localDriverDetail['source']]"
                                    tooltipPosition="top" src="assets/icon/pc.png" alt="">
                                <img class="p-mr-3" *ngIf="localDriverDetail['source']==1" [pTooltip]="'来源：'+this.source[localDriverDetail['source']]"
                                    tooltipPosition="top" src="assets/icon/execl.png" alt="">
                                <img class="p-mr-3" *ngIf="localDriverDetail['source']==2" [pTooltip]="'来源：'+this.source[localDriverDetail['source']]"
                                    tooltipPosition="top" src="assets/icon/wechat.png" alt="">
                                <img class="p-mr-3" *ngIf="localDriverDetail['source']==3" [pTooltip]="'来源：'+this.source[localDriverDetail['source']]"
                                    tooltipPosition="top" src="assets/icon/mobile.png" alt="">

                                <div class="auditor p-mr-3" *ngIf="this.bc.getAge(localDriverDetail['birthDate'])>0">
                                    {{this.bc.getAge(localDriverDetail['birthDate'])}}周岁
                                </div>
                                <div class="company-permit p-mr-3"
                                    *ngIf="this.bc.getAge(localDriverDetail['birthDate'])>0 && (this.bc.getAge(localDriverDetail['birthDate'])<18 ||
                                        this.bc.getAge(localDriverDetail['birthDate'])>60)"
                                    class="company-contract p-mr-3">
                                    <span *ngIf="this.bc.getAge(localDriverDetail['birthDate'])<18">年龄低于法定年限18周岁</span>
                                    <span *ngIf="this.bc.getAge(localDriverDetail['birthDate'])>60">年龄高于法定年限60周岁</span>
                                </div>

                                <div [class]="localDriverDetail['useStatus']==0 ? 'company-status' : 'company-permit'">
                                    {{useStatus[localDriverDetail['useStatus']]}}</div>

                                <div class="company-contract" *ngIf="localDriverDetail['checkFlag']==1">
                                    {{checkFlag[localDriverDetail['checkFlag']]}}</div>
                                <div class="company-success" *ngIf="localDriverDetail['checkFlag']==2">
                                    {{checkFlag[localDriverDetail['checkFlag']]}}</div>
                                <div class="company-permit" *ngIf="localDriverDetail['checkFlag']==3">
                                    {{localDriverDetail['checkLog']}}</div>

                                <div class="company-contract p-mr-3"
                                    *ngIf="this.bc.getExpireDays(localDriverDetail['endUseDate'],'',localDriverDetail['expiredWarnDay']) > 0">
                                    身份证{{this.bc.getExpireDays(localDriverDetail['endUseDate'],'',localDriverDetail['expiredWarnDay'])}}天后过期
                                </div>
                                <div class="company-permit p-mr-3"
                                    *ngIf="this.bc.getExpireDays(localDriverDetail['endUseDate'],'',localDriverDetail['expiredWarnDay']) < 0">
                                    身份证已过期{{this.bc.getExpireDays(localDriverDetail['endUseDate'],1,localDriverDetail['expiredWarnDay'])}}天
                                </div>

                                <div class="company-contract p-mr-3"
                                    *ngIf="this.bc.getExpireDays(localDriverDetail['drivingEndUseDate'],'',localDriverDetail['expiredWarnDay']) > 0">
                                    驾驶证{{this.bc.getExpireDays(localDriverDetail['drivingEndUseDate'],'',localDriverDetail['expiredWarnDay'])}}天后过期
                                </div>
                                <div class="company-permit p-mr-3"
                                    *ngIf="this.bc.getExpireDays(localDriverDetail['drivingEndUseDate'],'',localDriverDetail['expiredWarnDay']) < 0">
                                    驾驶证已过期{{this.bc.getExpireDays(localDriverDetail['drivingEndUseDate'],1,localDriverDetail['expiredWarnDay'])}}天
                                </div>

                                <div class="company-contract p-mr-3"
                                    *ngIf="this.bc.getExpireDays(localDriverDetail['qualificationCertExpireTime'],'',localDriverDetail['expiredWarnDay']) > 0">
                                    从业资格证{{this.bc.getExpireDays(localDriverDetail['qualificationCertExpireTime'],'',localDriverDetail['expiredWarnDay'])}}天后过期
                                </div>
                                <div class="company-permit p-mr-3"
                                    *ngIf="this.bc.getExpireDays(localDriverDetail['qualificationCertExpireTime'],'',localDriverDetail['expiredWarnDay']) < 0">
                                    从业资格证已过期{{this.bc.getExpireDays(localDriverDetail['qualificationCertExpireTime'],1,localDriverDetail['expiredWarnDay'])}}天
                                </div>

                                <div class="company-permit p-mr-3"*ngIf="localDriverDetail['isOwner'] ==2">
                                    车主
                                </div>

                            </div>
                        </div>
                        <div class="p-d-flex p-ai-center" style="position: absolute; left: 580px;top:0px;">
                            <div class="p-mr-2">
                                <img *ngIf="localDriverDetail['blacklistStatus']==1" src="assets/icon/stamp_blacklist.png" alt="">
                            </div>
                        </div>
                        <div class="hr"></div>
                        <!-- 基础详情表单 -->
                        <form class="detail-form" action="">
                            <!-- <div class="table-title">基础详情</div> -->
                            <div class="table-detail">
                                <div class="table-rows">
                                    <div class="table-tr">
                                        司机姓名
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{localDriverDetail['realname']}}
                                    </div>
                                    <div class="table-tr">
                                        政治面貌
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{this.politicalOutlookMap[localDriverDetail['politicalOutlook']]}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        性别
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{this.sex[localDriverDetail['sex']]}}
                                    </div>
                                    <div class="table-tr">
                                        出生年月
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{this.bc.setCreateDay(localDriverDetail['birthDate']*1000)}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        手机号
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{localDriverDetail['mobilePhone']}}
                                    </div>
                                    <div class="table-tr">
                                        身份证号
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{localDriverDetail['idCardNo']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        身份证有效期起
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{this.bc.setCreateDay(localDriverDetail['startUseDate']*1000)}}
                                    </div>
                                    <div class="table-tr">
                                        身份证有效期止
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{this.bc.setCreateDay(localDriverDetail['endUseDate']*1000)}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">地址</div>
                                    <div class="table-td table-td-address">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{localDriverDetail['address']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        从业资格证
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{localDriverDetail['qualificationCertNo']}}
                                    </div>
                                    <div class="table-tr">
                                        从业资格证失效日期
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{this.bc.setCreateDay(localDriverDetail['qualificationCertExpireTime']*1000)}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        准驾车型
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.driverTypeMap[localDriverDetail['driverType']]}}
                                    </div>
                                    <div class="table-tr">
                                        档案编号
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{localDriverDetail['drivingLicenseNo']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        驾驶证有效期起
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateDay(localDriverDetail['drivingStartUseDate']*1000)}}
                                    </div>
                                    <div class="table-tr">
                                        驾驶证有效期止
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateDay(localDriverDetail['drivingEndUseDate']*1000)}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        驾驶证发证机关
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        <span [pTooltip]="localDriverDetail['issuingOrganizations']"
                                            tooltipPosition="top">{{localDriverDetail['issuingOrganizations']}}</span>
                                    </div>
                                    <div class="table-tr">
                                        从业资格证颁发机构所在地
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        <span [pTooltip]="qualificationCertIssueArea"
                                            tooltipPosition="top">{{qualificationCertIssueArea || '暂无'}}</span>
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        从业资格证颁发机构所在地
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        <span [pTooltip]="qualificationCertIssueArea"
                                            tooltipPosition="top">{{qualificationCertIssueArea || '暂无'}}</span>
                                    </div>
                                    <div class="table-tr">
                                        注册时间
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateTime(localDriverDetail['createTime']*1000)}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        来源
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.source[localDriverDetail['source']]}}
                                    </div>
                                    <div class="table-tr">
                                        备注
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton>
                                        {{localDriverDetail['remark']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        审核时间
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{this.bc.setCreateTime(localDriverDetail['checkTime']*1000)}}
                                    </div>
                                    <div class="table-tr">
                                        审核人员
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo">
                                        </p-skeleton>
                                        {{localDriverDetail['checkName']}}
                                    </div>
                                </div>
                            </div>
                        </form>

                        <!-- 委托代开协议 -->
                        <form class="detail-form" action="">
                            <div class="table-detail">
                                <div class="table-rows">
                                    <div class="table-tr">委托代开协议</div>
                                    <div class="table-td table-td-address">
                                        <!-- <p-skeleton width="10rem" height="2rem" *ngIf="loadingDriverInfo"></p-skeleton> -->
                                        <a href="javascript:;" pRipple class="edit-font"
                                            (click)="showFadadaDriverAgree(localDriverDetail)">{{this.signStatus[localDriverDetail['signStatus']]}}</a>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <!--关联信息-->
                        <form class="detail-form" action="">
                            <div class="table-title">关联信息</div>
                            <p-accordion>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">
                                        我的车辆（{{this.relTruckList.length}}）
                                        <div *ngFor="let item of relTruckList ;let i = index">
                                            <p-chip *ngIf="i<6" [label]="item['plateNumber']" style="margin-left: 10px;"
                                                styleClass="p-mr-2 custom-chip"></p-chip>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="table-rows" style="background-color: var(--surface-d)">
                                            <div class="table-line">序号</div>
                                            <div class="table-line">车牌号</div>
                                            <div class="table-line">车辆类型</div>
                                            <div class="table-line">人车照片</div>
                                        </div>
                                        <div class="table-rows" *ngIf="relTruckList.length==0">
                                            <div class="table-line" *ngIf="!loadingRelInfo">
                                                暂无数据
                                            </div>
                                            <div class="table-line" *ngIf="loadingRelInfo">
                                                <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                            </div>
                                        </div>
                                        <div class="table-rows" *ngFor="let item of relTruckList ;let i = index">
                                            <div class="table-line">
                                                {{i+1}}
                                            </div>
                                            <div class="table-line">
                                                <a href="javascript:;" pRipple class="edit-font p-mr-2"
                                                    (click)="showTruckDetail(item)">{{item.plateNumber}}
                                                </a>
                                            </div>
                                            <div class="table-line">
                                                {{this.vehicleTypeMap[item.vehicleType]}}
                                            </div>
                                            <div class="table-line">
                                                <ng-container
                                                    *ngIf="item.driverTruckPhoto == '' || item.driverTruckPhoto == null">
                                                    <span style="color: red;">未上传</span>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="item.driverTruckPhoto != '' && item.driverTruckPhoto != null">
                                                    <a href="javascript:;" pRipple class="edit-font"
                                                        (click)="checkDriverTruckPhoto(item)" style="color: #4ea844;">已上传</a>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">银行卡（{{this.bankAccountList.length}}）
                                        <div *ngFor="let item of bankAccountList;let i = index">
                                            <p-chip *ngIf="i<3" [label]="item['accountNo']+'('+item['cardType']+')'" style="margin-left: 10px;"
                                                styleClass="p-mr-2 custom-chip"></p-chip>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="table-rows" style="background-color: var(--surface-d)">
                                            <div class="table-line">序号</div>
                                            <div class="table-line">所属银行</div>
                                            <div class="table-line">银行卡号</div>
                                            <div class="table-line">是否强制绑定</div>
                                        </div>
                                        <div class="table-rows" *ngIf="bankAccountList.length==0">
                                            <div class="table-line" *ngIf="!loadingRelInfo">
                                                暂无数据
                                            </div>
                                            <div class="table-line" *ngIf="loadingRelInfo">
                                                <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                            </div>
                                        </div>
                                        <div class="table-rows" *ngFor="let item of bankAccountList;let i = index">
                                            <div class="table-line">
                                                {{i+1}}
                                            </div>
                                            <div class="table-line">
                                                <span [pTooltip]="item.cardType"
                                                    tooltipPosition="top">{{item.cardType}}</span>
                                            </div>
                                            <div class="table-line">
                                                <span [pTooltip]="item.accountNo"
                                                    tooltipPosition="top">{{item.accountNo}}</span>
                                            </div>
                                            <div class="table-line">
                                                {{item.isForceName}}
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab>
                                <!-- <p-accordionTab>
                                    <ng-template pTemplate="header">代理商（{{this.relAgentList.length}}）
                                        <div *ngFor="let item of relAgentList;let i = index">
                                            <p-chip [label]="item['agentName']" style="margin-left: 10px;"
                                                styleClass="p-mr-2 custom-chip"></p-chip>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="table-rows" style="background-color: var(--surface-d)">
                                            <div class="table-line">序号</div>
                                            <div class="table-line">代理商名称</div>
                                            <div class="table-line">联系人</div>
                                            <div class="table-line">联系电话</div>
                                        </div>
                                        <div class="table-rows" *ngIf="relAgentList.length==0">
                                            <div class="table-line" *ngIf="!loadingRelInfo">
                                                暂无数据
                                            </div>
                                            <div class="table-line" *ngIf="loadingRelInfo">
                                                <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                            </div>
                                        </div>
                                        <div class="table-rows" *ngFor="let item of relAgentList;let i = index">
                                            <div class="table-line">
                                                {{i+1}}
                                            </div>
                                            <div class="table-line">
                                                <a href="javascript:;" pRipple class="edit-font"
                                                    (click)="showAgentDetail(localAgentorDetail)"
                                                    [pTooltip]="item.agentName" tooltipPosition="top">
                                                    {{item.agentName}}
                                                </a>
                                            </div>
                                            <div class="table-line">
                                                <span [pTooltip]="item.contactName"
                                                    tooltipPosition="top">{{item.contactName}}</span>
                                            </div>
                                            <div class="table-line">
                                                <span [pTooltip]="item.contactPhone"
                                                    tooltipPosition="top">{{item.contactPhone}}</span>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">货主（{{this.relCusList.length}}）
                                        <div *ngFor="let item of relCusList;let i = index">
                                            <p-chip [label]="item['name']" style="margin-left: 10px;"
                                                styleClass="p-mr-2 custom-chip"></p-chip>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="table-rows" style="background-color: var(--surface-d)">
                                            <div class="table-line">序号</div>
                                            <div class="table-line">货主名称</div>
                                            <div class="table-line">联系人</div>
                                            <div class="table-line">联系电话</div>
                                        </div>
                                        <div class="table-rows" *ngIf="relCusList.length==0">
                                            <div class="table-line" *ngIf="!loadingRelInfo">
                                                暂无数据
                                            </div>
                                            <div class="table-line" *ngIf="loadingRelInfo">
                                                <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                            </div>
                                        </div>
                                        <div class="table-rows" *ngFor="let item of relCusList;let i = index">
                                            <div class="table-line">
                                                {{i+1}}
                                            </div>
                                            <div class="table-line">
                                                <a href="javascript:;" pRipple class="edit-font" [pTooltip]="item.name"
                                                    tooltipPosition="top"
                                                    (click)="showShipperDetail(localAgentorDetail)">{{item.name}}
                                                </a>
                                            </div>
                                            <div class="table-line">
                                                <span [pTooltip]="item.legalPerson"
                                                    tooltipPosition="top">{{item.legalPerson}}</span>
                                            </div>
                                            <div class="table-line">
                                                <span [pTooltip]="item.legalPhone"
                                                    tooltipPosition="top">{{item.legalPhone}}</span>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab> -->
                                <!-- <p-accordionTab>
                                    <ng-template pTemplate="header">车队长（{{this.relAgentorList.length}}）
                                        <div *ngFor="let item of relAgentorList;let i = index">
                                            <p-chip [label]="item['realname']" style="margin-left: 10px;"
                                                styleClass="p-mr-2 custom-chip"></p-chip>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="table-rows" style="background-color: var(--surface-d)">
                                            <div class="table-line">序号</div>
                                            <div class="table-line">姓名</div>
                                            <div class="table-line">联系方式</div>
                                            <div class="table-line">代收协议</div>
                                        </div>
                                        <div class="table-rows" *ngIf="relAgentorList.length==0">
                                            <div class="table-line" *ngIf="!loadingRelInfo">
                                                暂无数据
                                            </div>
                                            <div class="table-line" *ngIf="loadingRelInfo">
                                                <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                            </div>
                                        </div>
                                        <div class="table-rows" *ngFor="let item of relAgentorList;let i = index">
                                            <div class="table-line">
                                                {{i+1}}
                                            </div>
                                            <div class="table-line">
                                                <a href="javascript:;" pRipple class="edit-font"
                                                    (click)="showShipperDetail(localAgentorDetail)"
                                                    [pTooltip]="item.realname" tooltipPosition="top">{{item.realname}}
                                                </a>
                                            </div>
                                            <div class="table-line">
                                                <span [pTooltip]="item.mobilePhone"
                                                    tooltipPosition="top">{{item.mobilePhone}}</span>
                                            </div>
                                            <div class="table-line">
                                                <ng-container *ngIf="item.agentAgree == '' || item.agentAgree == null">
                                                    <span style="color: red;">未上传</span>
                                                </ng-container>
                                                <ng-container *ngIf="item.agentAgree != '' && item.agentAgree != null">
                                                    <a href="javascript:;" pRipple class="edit-font"
                                                        (click)="checkAgentAgreePhoto(item)" style="color: #4ea844;">已上传</a>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab> -->
                            </p-accordion>
                        </form>

                        <!-- 我的车辆表单
                        <form action="">
                            <div class="table-title">我的车辆</div>
                            <div class="table-detail">
                                <div class="table-rows" style="background-color: var(--surface-d)">
                                    <div class="table-line">序号</div>
                                    <div class="table-line">车牌号</div>
                                    <div class="table-line">车辆类型</div>
                                    <div class="table-line">人车照片</div>
                                </div>
                                <div class="table-rows" *ngFor="let item of relTruckList ;let i = index">
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{i+1}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        <a href="javascript:;" pRipple class="edit-font p-mr-2"
                                            (click)="showTruckDetail(item)">{{item.plateNumber}}
                                        </a>
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{this.vehicleTypeMap[item.vehicleType]}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        <ng-container *ngIf="item.driverTruckPhoto == '' || item.driverTruckPhoto == null">
                                            <span style="color: red;">未上传</span>
                                        </ng-container>
                                        <ng-container *ngIf="item.driverTruckPhoto != '' && item.driverTruckPhoto != null">
                                            <a href="javascript:;" pRipple class="edit-font" style="color: #4ea844;">已上传</a>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </form>-->
                        <!-- 我的银行卡
                        <form action="">
                            <div class="table-title">我的银行卡</div>
                            <div class="table-detail">
                                <div class="table-rows" style="background-color: var(--surface-d)">
                                    <div class="table-line">序号</div>
                                    <div class="table-line">所属银行</div>
                                    <div class="table-line">银行卡号</div>
                                    <div class="table-line">是否强制绑定</div>
                                </div>
                                <div class="table-rows" *ngFor="let item of bankAccountList;let i = index">
                                    <div class="table-line"><p-skeleton *ngIf="loadingRelInfo"></p-skeleton>{{i+1}}</div>
                                    <div class="table-line"><p-skeleton *ngIf="loadingRelInfo"></p-skeleton>{{item.cardType}}</div>
                                    <div class="table-line"><p-skeleton *ngIf="loadingRelInfo"></p-skeleton>{{item.accountNo}}</div>
                                    <div class="table-line"><p-skeleton *ngIf="loadingRelInfo"></p-skeleton>{{item.isForceName}}</div>
                                </div>
                            </div>
                        </form>-->
                        <!-- 关联代理商
                        <form action="">
                            <div class="table-title">关联代理商</div>
                            <div class="table-detail">
                                <div class="table-rows" style="background-color: var(--surface-d)">
                                    <div class="table-line">序号</div>
                                    <div class="table-line">代理商名称</div>
                                    <div class="table-line">联系人</div>
                                    <div class="table-line">联系电话</div>
                                </div>
                                <div class="table-rows" *ngFor="let item of relAgentList;let i = index">
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{i+1}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        <a href="javascript:;" pRipple class="edit-font"
                                            (click)="showAgentDetail(localAgentorDetail)">{{item.agentName}}
                                        </a>
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{item.contactName}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{item.contactPhone}}
                                    </div>
                                </div>
                            </div>
                        </form>-->
                        <!-- 关联货主
                        <form action="">
                            <div class="table-title">关联货主</div>
                            <div class="table-detail">
                                <div class="table-rows" style="background-color: var(--surface-d)">
                                    <div class="table-line">序号</div>
                                    <div class="table-line">货主名称</div>
                                    <div class="table-line">联系人</div>
                                    <div class="table-line">联系电话</div>
                                </div>
                                <div class="table-rows" *ngFor="let item of relCusList;let i = index">
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{i+1}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        <a href="javascript:;" pRipple class="edit-font"
                                            (click)="showShipperDetail(localAgentorDetail)">{{item.name}}
                                        </a>
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{item.legalPerson}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{item.legalPhone}}
                                    </div>
                                </div>
                            </div>
                        </form>-->
                        <!-- 我的车队长
                        <form action="">
                            <div class="table-title">我的车队长</div>
                            <div class="table-detail">
                                <div class="table-rows" style="background-color: var(--surface-d)">
                                    <div class="table-line">序号</div>
                                    <div class="table-line">姓名</div>
                                    <div class="table-line">联系方式</div>
                                    <div class="table-line">代收协议</div>
                                </div>
                                <div class="table-rows" *ngFor="let item of relAgentorList;let i = index">
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{i+1}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        <a href="javascript:;" pRipple class="edit-font"
                                            (click)="showShipperDetail(localAgentorDetail)">{{item.realname}}
                                        </a>
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{item.mobilePhone}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        <ng-container *ngIf="item.agentAgree == '' || item.agentAgree == null">
                                            <span style="color: red;">未签署</span>
                                        </ng-container>
                                        <ng-container *ngIf="item.agentAgree != '' && item.agentAgree != null">
                                            <a href="javascript:;" pRipple class="edit-font" style="color: #4ea844;">已签署</a>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </form>-->
                    </div>
                </td>
                <td class="panel-right">
                    <!-- 右 -->
                    <div class="panel-list panel-background">
                        <!-- tab -->
                        <div class="panel-right-top">
                            <!-- tab -->
                            <div *ngFor="let item of tabList index as i" class="tabBar">
                                <div class="tabBar-item" [ngClass]="activeIndex == i ? 'active' : ''"
                                    (click)="handleTabClick(i)">
                                    {{item}}
                                </div>
                            </div>
                        </div>
                        <!-- 统计数据 -->
                        <div *ngIf="activeIndex == 0" style="margin-top: 1.714286rem;">
                            <!-- 图表区域 -->
                            <div class="chart p-d-flex p-ai-center p-jc-around">
                                <div class="chart-container">
                                    <div class="panel-right-title" style="position: absolute;top: -2px;left: 0;">运单数据
                                    </div>
                                    <p-chart type="bar" width="auto" height="300px" [responsive]="true"
                                        [data]="chartData" [options]="chartOptions">
                                    </p-chart>
                                </div>
                            </div>

                            <div class='count-container p-d-flex p-ai-center p-jc-between'>
                                <div class="count-item">
                                    <img class="count-item-img" src="assets/icon/count-item2.png" alt="">
                                    <div class="count-item-title">{{warningTitle}}</div>
                                    <div class="count-item-num">{{this.bc.getFormatNumberToFixed(driverWayibllMoney)}}
                                        <img class="count-item-icon" src="assets/icon/overfulfil.png" *ngIf="warningFlag" alt="">
                                    </div>
                                </div>
                                <div class="count-hr"></div>
                                <div class="count-item">
                                    <img class="count-item-img" src="assets/icon/count-item1.png" alt="">
                                    <div class="count-item-title">累计运单数(单)</div>
                                    <div class="count-item-num">{{driverWaybillNum}}</div>
                                </div>
                                <div class="count-hr"></div>
                                <div class="count-item">
                                    <img class="count-item-img" src="assets/icon/count-item3.png" alt="">
                                    <div class="count-item-title">累计承运费(元)</div>
                                    <div class="count-item-num">{{this.bc.getFormatNumberToFixed(driverWayibllMoneyTotal)}}</div>
                                </div>
                                <div class="count-hr"></div>
                                <div class="count-item">
                                    <img class="count-item-img" src="assets/icon/count-item4.png" alt="">
                                    <div class="count-item-title">货主评价</div>
                                    <div class="count-item-num">100%</div>
                                </div>
                            </div>
                            <!-- 常跑路线 -->
                            <div class="panel-right-title" style="margin-top: 20px; margin-bottom: 8px;">
                                常跑路线
                            </div>
                            <div class="p-d-flex p-ai-center p-flex-wrap">
                                <div class="route-item p-d-flex p-ai-center p-jc-around" *ngIf="areaList.length==0">
                                    暂无数据
                                </div>
                                <div class="route-item p-d-flex p-ai-center p-jc-around" *ngFor="let item of areaList;let i = index">
                                    <div class=" route-item-address">
                                        {{item['startAreaName']}}
                                    </div>
                                    <div class="route-item-mid p-d-flex p-jc-between">
                                        <img class="route-left-icon" src="assets/icon/Rectangle 201.png" alt="">
                                        <span>至</span>
                                        <img class="route-right-icon" src="assets/icon/Union.png" alt="">
                                    </div>
                                    <div class="route-item-address">
                                        {{item['endAreaName']}}
                                    </div>
                                </div>
                            </div>
                            <!-- 饼状图 -->
                            <div style="margin-top: 20px;position: relative;">
                                <div class="panel-right-title" style="margin-bottom: 10px;">
                                    运输货物类型占比
                                </div>
                            </div>
                            <p-chart width="auto" [responsive]="true" type="doughnut" [data]="goodsType"
                                [options]="goodsTypeOptions">
                            </p-chart>
                        </div>
                        <!-- 照片资料 -->
                        <div *ngIf="activeIndex == 1">
                            <div class="photo-detail">
                                <!--图片描述 -->
                                <div class="img-describe">{{imgDescribe}}</div>
                                <div class="img-container">
                                    <!-- 大图 -->
                                    <div class="img-preview">
                                        <img image-viewer (click)="previewThumbnailImage()"
                                            [src]="imgPriview?imgPriview:thumbnailImageSrc[0]['url']"
                                            class="img-preview-img">
                                    </div>
                                    <!-- 功能区 -->
                                    <div class="function-container">
                                        <div class="function-item turnLeft" (click)="handleTurnLeft()">
                                            <img src="assets/icon/tleft.png" alt="">
                                        </div>
                                        <div class="function-item turnRight" (click)="handleTurnright()">
                                            <img src="assets/icon/tright.png" alt="">
                                        </div>
                                    </div>
                                </div>
                                <!-- 小图列表 -->
                                <div class="img-list">
                                    <div class="img-list-previous">
                                        <img src="assets/icon/Vector 34.png" alt="">
                                    </div>
                                    <!-- 遍历 -->
                                    <div style="margin: 0 40px;" class="p-d-flex p-ai-center p-jc-center">
                                        <div class="img-list-item" [ngClass]="previewImgIndex == i? 'onactive':''"
                                            *ngFor="let item of thumbnailImageSrc index as i">
                                            <img (click)="handlePreviewImgClick(item,i)" class="" [src]="item.url">
                                            <div class="img-describe-little-mask">
                                                <div class="img-describe-little">{{item.title}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="img-list-next">
                                        <img src="assets/icon/Vector 35.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>


<!-- 车辆详情 -->
<p-detail-sidebar *ngIf="showTruckDetailDialog" [(visible)]="showTruckDetailDialog" [showCloseIcon]="false"
    position="right" [style]="{width: percentWidth - 10 + '%'}" transitionOptions="600ms ease-in-out" appendTo="body">
    <app-truck-detail [truckDetail]="truckDetail" (onClose)="showTruckDetailDialog = false"
        [percentWidth]="percentWidth - 10">
    </app-truck-detail>
</p-detail-sidebar>

<!--查看法大大协议开始-->
<p-dialog [header]="agreeHeaderTitle" class="edit-order" *ngIf="showFadadaDriverFlag" [(visible)]="showFadadaDriverFlag" position="center" [dismissableMask] = "true"
        [modal]="true" [style]="{width:'60%', overFlow:'auto'}" [baseZIndex]="10000">
    <iframe sandbox="allow-same-origin allow-scripts allow-top-navigation allow-forms" scrolling='auto' frameborder='0' [src]="safeUrl" [style]="{width:'100%',height:'700px'}"></iframe>
</p-dialog>
<!--查看法大大协议结束-->
